import { useMemo } from 'react';
import * as fmt from '../lib/format.js';
import { goalBand, verdict, weeklySummaries, type DayRow, type Goal } from '../lib/stats.js';

interface Props {
  series: DayRow[];
  goal: Goal;
}

export function WeeksCard({ series, goal }: Props) {
  const weeks = useMemo(() => weeklySummaries(series), [series]);

  return (
    <section className="card weeks">
      <h2 className="card__title" style={{ marginBottom: 14 }}>
        Bilan par semaine
      </h2>

      <div className="weeks__row weeks__head">
        <span>Semaine</span>
        <span>Poids</span>
        <span>Δ</span>
        <span>Pas/j</span>
        <span>Kcal/j</span>
      </div>

      {weeks.map((week) => {
        // La bande est un pourcentage du poids : chaque semaine est jugée au
        // poids qu'elle avait, pas au poids d'aujourd'hui.
        const band = goalBand(goal, week.weight);
        return (
          <div className="weeks__row weeks__body" key={week.key}>
            <span className="weeks__label">{fmt.range(week.from, week.to)}</span>
            <span title={`${week.days} pesée${week.days > 1 ? 's' : ''}`}>
              {fmt.weight(week.weight)}
            </span>
            <span
              style={{ color: week.delta == null ? 'var(--ink3)' : verdict(week.delta, band, goal).color }}
            >
              {fmt.delta(week.delta)}
            </span>
            <span className="weeks__label">{fmt.number(week.steps)}</span>
            <span className="weeks__label">{fmt.number(week.kcal)}</span>
          </div>
        );
      })}

      <p className="weeks__note">
        Poids et Δ sont des moyennes sur sept jours, exigées à quatre pesées
        minimum : un bloc de sept jours contient chaque jour de la semaine une
        fois, ce qui annule le creux du vendredi et la bosse du lundi.
      </p>
    </section>
  );
}
